function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 11.7894,
  cy: 8.47368,
  r: 2.97368,
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6316 18.3158H6.05159C6.0231 18.3158 6 18.2927 6 18.2642V18.2642C6 15.415 8.30973 13.1052 11.1589 13.1052H11.7895",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 15L14 18L12.5 16.5",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/refer.020b7832.svg";
export { SvgComponent as ReactComponent };